import { render, staticRenderFns } from "./customer.vue?vue&type=template&id=7e07f4be&scoped=true&"
import script from "./customer.vue?vue&type=script&lang=js&"
export * from "./customer.vue?vue&type=script&lang=js&"
import style0 from "./customer.vue?vue&type=style&index=0&id=7e07f4be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e07f4be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e07f4be')) {
      api.createRecord('7e07f4be', component.options)
    } else {
      api.reload('7e07f4be', component.options)
    }
    module.hot.accept("./customer.vue?vue&type=template&id=7e07f4be&scoped=true&", function () {
      api.rerender('7e07f4be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/InventoryManagement/Inventory/form/add/components/customer.vue"
export default component.exports